import { RelatedBankOrders } from "@app/relatedBankOrders"
import { useOrderFormContext } from "."

export const OrderInfoTabs = () => {
  const { model } = useOrderFormContext();
  const { bgBankOrders } = model!.components!;

  return (
    <RelatedBankOrders carts={bgBankOrders?.carts || []} orders={bgBankOrders?.orders || []} />
  )
}
